/* istanbul ignore file */
export * from './LegalHintsItem';
